import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import ROLES from 'config/roles';
import ROUTES from 'config/routes';
import history from 'services/history';
import AuthModule from 'modules/auth';
import {userTypesCaregivers} from 'config/constants';
import ResumeModule from "../../modules/resumes";


const ProfileMenuList = (props) =>  {
  const {logOut, role, onClickOutside, resume, token, getResumeAvailable} = props;

  useEffect(() => {
    const { } = props;
    token && getResumeAvailable();
  },[props.token]);

  return (
    <>
      <ul className="header-profile__menu-list">
        <li className="header-profile__menu-item">
          <button
            onClick={() => {
              history.push({pathname: ROUTES.profileInfo});
              onClickOutside();
            }}
            className="header-profile__menu-link">My profile
          </button>
        </li>
        {
          (role === ROLES.FAMILY_OR_FRIEND
            || role === ROLES.AGENCY
            || role === ROLES.SELF
            || role === ROLES.STUDENT) &&
          <li className="header-profile__menu-item">
            <button
              onClick={() => {
                history.push({pathname: ROUTES.profileJobListing});
                onClickOutside();
              }}
              className="header-profile__menu-link">My job listings
            </button>
          </li>
        }
        {
          (role === ROLES.PROFESSIONAL_IN_FACILITY
            || role === ROLES.PROFESSIONAL_IN_HOME_AND_FACILITY
            || role === ROLES.PROFESSIONAL_IN_HOME) &&
          <li className="header-profile__menu-item">
            <button
              title="Click here to CREATE, EDIT/UPDATE, HIDE FROM SEARCHES, or DELETE"
              onClick={() => {
                history.push({pathname:
                        Object.keys(resume).length ? `${ROUTES.editResume}/${resume.id}` : ROUTES.createResume});
                onClickOutside();
              }}
              className="header-profile__menu-link">My application
            </button>
          </li>
        }

        {
          role !== ROLES.FAMILY_OR_FRIEND &&
          userTypesCaregivers.find(item => item.slug === role) &&
          <li className="header-profile__menu-item">
            <button
              onClick={() => {
                  history.push({pathname: ROUTES.profileRequirements});
                onClickOutside();
              }}
              className="header-profile__menu-link">My preferences
            </button>
          </li>
        }
          {
              (role === ROLES.PROFESSIONAL_IN_FACILITY
                  || role === ROLES.PROFESSIONAL_IN_HOME_AND_FACILITY
                  || role === ROLES.PROFESSIONAL_IN_HOME) &&
              <li className="header-profile__menu-item">
                  <button
                      onClick={() => {
                          history.push({pathname: Object.keys(resume).length ? ROUTES.catalogJobs : ROUTES.createResume});
                          onClickOutside();
                      }}
                      className="header-profile__menu-link">My opportunities
                  </button>
              </li>
          }
        {
          role !== ROLES.COMPANY &&
          role !== ROLES.FACILITY &&
          role !== ROLES.PROFESSIONAL_IN_HOME_AND_FACILITY &&
          role !== ROLES.PROFESSIONAL_IN_HOME &&
          role !== ROLES.PROFESSIONAL_IN_FACILITY &&
          <li className="header-profile__menu-item">
            <Link
              to={ROUTES.jobChoosing}
              className="header-profile__menu-link">
                My candidates
            </Link>
          </li>
        }
        {
          role !== ROLES.COMPANY &&
          role !== ROLES.FACILITY &&
          <li className="header-profile__menu-item">
            <Link
              to={ROUTES.profileFavorites}
              className="header-profile__menu-link">{
                  role === ROLES.PROFESSIONAL_IN_HOME_AND_FACILITY ||
                  role === ROLES.PROFESSIONAL_IN_HOME ||
                  role === ROLES.PROFESSIONAL_IN_FACILITY ?
                  'My favorite jobs' : 'My favorite candidates'}</Link>
          </li>
        }
        <li className="header-profile__menu-item">
          <button
            onClick={() => {
              history.push({pathname: ROUTES.profilePassword});
              onClickOutside();
            }}
            className="header-profile__menu-link">My password
          </button>
        </li>
        {
          (role === ROLES.AGENCY || role === ROLES.COMPANY || role === ROLES.FACILITY) &&
          <li className="header-profile__menu-item">
            <button
              onClick={() => {
                history.push({pathname: ROUTES.profileAdverts});
                onClickOutside();
              }}
              className="header-profile__menu-link">My advertisements
            </button>
          </li>
        }
        {
          (role === ROLES.AGENCY || role === ROLES.COMPANY || role === ROLES.STUDENT || role === ROLES.FACILITY) &&
          <li className="header-profile__menu-item">
            <button
              onClick={() => {
                history.push({pathname: ROUTES.profileForum});
                onClickOutside();
              }}
              className="header-profile__menu-link">My forum content
            </button>
          </li>
        }
      </ul>
      <div className="header-profile__menu-item">
        <button
          className="header-profile__menu-link"
          onClick={logOut}>Log out
        </button>
      </div>
    </>
  )
}


export default connect(
  state => ({
      token: state.auth.token,
      resume: state.resumes.available.info
  }),
  {
    getResumeAvailable: ResumeModule.getResumeAvailable,
    logOut: AuthModule.logOut,
  }
)(ProfileMenuList);
